import React, { Component } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import ReactGA from 'react-ga'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import Howto from './components/Howto/Howto'
import Cards from './components/Cards/Cards'
import Card from './components/Card/Card'
/*import Orders from './components/Orders/Orders'
import OrdersPaypalIpay from './components/Orders/OrdersPaypalIpay'*/
import OrdersIpay from './components/Orders/OrdersIpay'
import Purchases from './components/Purchases/Purchases'
import Contacts from './components/Contacts/Contacts'
import Transactions from './components/Transactions/Transactions'
import Faq from './components/Faq/Faq'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import Signup from './components/Signup/Signup'
import { API_ROOT, AUTH_BASIC } from './config';

ReactGA.initialize('UA-138687522-1', {
  'siteSpeedSampleRate': 100
})
ReactGA.pageview(window.location.pathname + window.location.search)

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      savedCount: 0,
      subject: null
    }
  }

  seoCardDetail = ( {match} ) => (
    <Card categ={match.params.categ} cdname={match.params.cdname} savedCount={this.updateSavedCount} subject={this.updateSubject} />
  )

  cardDetail = ( {match} ) => (
    <Card cdid={match.params.cdid} savedCount={this.updateSavedCount} subject={this.updateSubject} />
  )

  savedCardDetail = ( {match} ) => (
    <Card cdid={match.params.cdid} savedCount={this.updateSavedCount} subject={this.updateSubject} orderid={match.params.orderid} />
  )

  orderList = ( {match} ) => (
    <OrdersIpay savedCount={this.updateSavedCount} />
  )

  orderSingle = ( {match} ) => (
    <OrdersIpay savedCount={this.updateSavedCount} subject={this.updateSubject} orderid={match.params.orderid} />
  )

  seoCardCategory = ( {match} ) => (
    <Cards categ={match.params.categ} />
  )

  cardCategory = ( {match} ) => (
    <Cards categoryid={parseInt(match.params.categoryid, 10)} />
  )

  purchaseList= ( {match} ) => (
    <Purchases subject={this.updateSubject} />
  )

  updateSavedCount = (increment) => {
    this.setState({savedCount:this.state.savedCount + increment})
  }

  updateSubject = (subject) => {
    this.setState({subject:subject});
  }

  render() {
    return (
      <Router><React.Fragment>
        <Header savedCount={this.state.savedCount} subject={this.state.subject} />
        <Switch>
          <Route exact path="/" component={Howto}/>

          <Route path="/category/:categoryid" component={this.cardCategory} />
          <Route path="/:categ-cards/:cdname" component={this.seoCardDetail} />
          <Route path="/:categ-cards" component={this.seoCardCategory} />
          <Route path="/cards/:cdid/orders/:orderid" component={this.savedCardDetail}/>
          <Route path="/cards/:cdid" component={this.cardDetail}/>
          <Route path="/cards" component={Cards}/>

          <Route path="/orders/:orderid" component={this.orderSingle}/>
          <Route path="/orders" component={this.orderList}/>
          {/*<Route path="/ordersipay" component={this.orderIpayList}/>
          <Route path="/orderspaypalipay" component={this.orderPaypalIpayList}/>*/}

          <Route path="/purchases" component={this.purchaseList}/>
          <Route path="/contacts" component={Contacts}/>
          <Route path="/faq" component={Faq}/>
          <Route path="/transactions/:transid" component={Transactions}/>

          <Route path="/signup" component={Signup}/>
        </Switch>
        <div style={{height: 50 + 'px'}}></div>
        <Footer />
        <ScrollToTop />
      </React.Fragment></Router>
    );
  }

  componentDidMount () {
    const token = localStorage.getItem('token');
    if(token){
      //console.log(token)
      fetch(`${API_ROOT}/orders/counts`,{
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      .then (response => {
        if (response.ok) {
          return response.json()
        }
      })
      .then (data => {
        this.setState({savedCount:data.orders.counts})
      })
      .catch((error) => {

      })
    }
    else {
      const hash = new Buffer(`${AUTH_BASIC}`).toString('base64')
      //console.log(hash)
      fetch(`${API_ROOT}/auth`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + hash
        }
      })
      .then ( response => {
        if ( response.ok ) {
          return response.json();
        }
      })
      .then ( data => {
        localStorage.setItem('token', data.token)
      })
      .catch ( (error) => {
        //console.log(error)
      })
    }

  }
}

export default App;
